import api from './client';

export interface MarketingCheck {
  pillar: 'content' | 'seo' | 'product';
  check_key: string;
  title: string;
  severity: 'critical' | 'warning' | 'info';
  passed: boolean;
  description: string;
  recommendation: string;
}

export interface MarketingRecommendation {
  priority: 'high' | 'medium' | 'low';
  category: string;
  title: string;
  action: string;
  expected_impact: string;
}

export interface MarketingAudit {
  id: number;
  status: 'completed' | 'failed';
  overall_score: number;
  grade: 'A' | 'B' | 'C' | 'D' | 'F';
  passed: boolean;
  pillar_scores: { content: number; seo: number; product: number };
  checks: MarketingCheck[];
  ai_recommendations: MarketingRecommendation[];
  summary_stats: {
    total_checks: number;
    passed_checks: number;
    failed_checks: number;
    products_analyzed: number;
    pages_analyzed: number;
  };
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export const marketingAuditApi = {
  list: (page = 1) =>
    api.get<{ data: MarketingAudit[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/marketing-audit?page=${page}`
    ),

  run: () => api.post<{ data: MarketingAudit }>('/marketing-audit'),

  latest: () => api.get<{ data: MarketingAudit }>('/marketing-audit/latest'),

  show: (id: number) => api.get<{ data: MarketingAudit }>(`/marketing-audit/${id}`),

  destroy: (id: number) => api.delete(`/marketing-audit/${id}`),
};
